import { ref, watch } from 'vue'

const KEY = 'kedo:nav:collapsed'

// The explicit collapse/expand toggle is the single source of truth: once the
// user toggles, the stored value wins on every page (including the KB). We only
// default to collapsed on a first KB visit when nothing has been stored yet —
// this never overrides a manual choice.
function getInitial() {
    const stored = localStorage.getItem(KEY)
    if (stored !== null) return stored === '1'
    return window.location.pathname.startsWith('/knowledge')
}

const collapsed = ref(getInitial())
watch(collapsed, v => localStorage.setItem(KEY, v ? '1' : '0'))

export function useNavCollapsed() {
    return { collapsed, toggle: () => { collapsed.value = !collapsed.value } }
}
